import React, { useEffect } from "react";
import "./overview.scss";
import TransactionData from "./overviewComponents/TransactionData";
import ComplaintsTable from "./overviewComponents/ComplaintsTable";
import { CategoryModeChart } from "./overviewComponents/PieChart";
import { useDispatch, useSelector } from "react-redux";

import SimplData from "./overviewComponents/SimplData";
import AllInOneChart from "./overviewComponents/AllInOneChart";
import { PaymentModeChart } from "./overviewComponents/PieChart";
import { TransactionStatusChart } from "./overviewComponents/PieChart";

function Overview() {
  return (
    <div className="main">
      <div className="part1">
        <TransactionData />
      </div>
      <div className="part2">
        <div className="internalPart2">
          <div className="piechart">
            <div className="chart-card category-mode-card">
              <CategoryModeChart />
            </div>
            <div className="piechart-right">
              <TransactionStatusChart />
              <PaymentModeChart />
            </div>
          </div>
        </div>
      </div>
      <div className="part3">
        <AllInOneChart />
      </div>
    </div>
  );
}

export default Overview;
